import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ContactClientEntity } from './contact-client.entity';
import { ContactRoleEntity } from './contact-role.entity';

/**
 * Where a role came from. `manual` roles are a person's choice and are never
 * removed by matching; the others are refreshed from the records' titles, ERP
 * roles and legacy type codes.
 */
export type ContactClientRoleSource = 'manual' | 'erp_title' | 'erp_role' | 'legacy_type';

/** A role a person holds at one customer (several allowed). PD-17064. */
@Index('contact_client_role__link_role', ['fkContactClientId', 'fkContactRoleId'], {
	unique: true,
})
@Index('contact_client_role__fk_role', ['fkContactRoleId'], {})
@Entity('contact_client_role')
export class ContactClientRoleEntity extends BaseEntity {
	@Column('int', { name: 'fk_contact_client__id', unsigned: true })
	public fkContactClientId!: number;

	@Column('int', { name: 'fk_contact_role__id', unsigned: true })
	public fkContactRoleId!: number;

	@Column('varchar', { name: 'source', length: 32 })
	public source!: ContactClientRoleSource;

	@ManyToOne(() => ContactClientEntity, (link) => link.roles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_contact_client__id', referencedColumnName: 'id' }])
	public contactClient!: ContactClientEntity;

	@ManyToOne(() => ContactRoleEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_contact_role__id', referencedColumnName: 'id' }])
	public role!: ContactRoleEntity;
}
